/**
 * @generated SignedSource<<9c9be116223b7c99d8062f9d4d14450b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SpaceRole = "SPACE_MEMBERS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FolderPermissionRules_folder$data = {
  readonly canModifyOwners: {
    readonly value: boolean;
  };
  readonly folderPermissions: {
    readonly canCreateFolderIn: {
      readonly allowedMembers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly avatar: {
              readonly name: string | null;
              readonly url: URIString;
            } | null;
            readonly id: string;
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
          } | null;
        }>;
      };
      readonly allowedRoles: ReadonlyArray<SpaceRole>;
    };
    readonly canCreateItemIn: {
      readonly allowedMembers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly avatar: {
              readonly name: string | null;
              readonly url: URIString;
            } | null;
            readonly id: string;
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
          } | null;
        }>;
      };
      readonly allowedRoles: ReadonlyArray<SpaceRole>;
    };
  } | null;
  readonly id: string;
  readonly ownershipSpace: {
    readonly id: string;
  };
  readonly " $fragmentType": "FolderPermissionRules_folder";
};
export type FolderPermissionRules_folder$key = {
  readonly " $data"?: FolderPermissionRules_folder$data;
  readonly " $fragmentSpreads": FragmentRefs<"FolderPermissionRules_folder">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowedRoles",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberConnection",
    "kind": "LinkedField",
    "name": "allowedMembers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Member",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserHandle_member"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FolderPermissionRules_folder",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canModifyOwners",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "ownershipSpace",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "folderPermissions",
      "args": null,
      "concreteType": "FolderNodePermissionConfig",
      "kind": "LinkedField",
      "name": "permissionConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PermissionRule",
          "kind": "LinkedField",
          "name": "canCreateFolderIn",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PermissionRule",
          "kind": "LinkedField",
          "name": "canCreateItemIn",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Folder",
  "abstractKey": null
};
})();

(node as any).hash = "c1a434b80c5ac220fd3314f8d641e495";

export default node;
